import React, { useState } from "react";
import "../Styles/header.css";

const CalendlyModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center">
      {/* Blurred background */}
      <div
        className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* Modal content */}
      <div className="relative z-10 mx-4 w-full max-w-2xl rounded-lg bg-white p-0 shadow-lg">
        <button
          className="absolute right-2 top-2 text-2xl font-bold text-gray-500 hover:text-gray-700"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <iframe
          src="https://calendly.com/consult-scaftechservices"
          title="Book Free Consultation"
          className="h-[550px] w-full rounded-lg"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

const WhatsAppFAB = () => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  const whatsappUrl = "https://wa.me/2348161637797";

  const handleWhatsAppClick = () => {
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      {/* Calendly modal */}
      <CalendlyModal
        open={isCalendlyOpen}
        onClose={() => setIsCalendlyOpen(false)}
      />

      {/* FAB stack */}
      <div className="fixed bottom-6 right-6 z-[1000] flex flex-col items-end gap-3">
        {/* Calendly FAB */}
        <button
          onClick={() => setIsCalendlyOpen(true)}
          aria-label="Book a consultation"
          className="
            flex h-12 w-12 items-center justify-center rounded-full
            bg-white text-[#082b6c]
            shadow-xl transition-all duration-300
            hover:scale-110 hover:bg-slate-100
            focus:outline-none focus:ring-4 focus:ring-[#082b6c]/30
          "
        >
          {/* Simple calendar icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
            <rect x="9" y="14" width="2.5" height="2.5" rx="0.4" />
          </svg>
        </button>

        {/* WhatsApp FAB */}
        <button
          onClick={handleWhatsAppClick}
          aria-label="Chat on WhatsApp"
          className="
            flex h-14 w-14 items-center justify-center
            rounded-full bg-[#00ad0f]
            text-white shadow-xl
            transition-all duration-300
            hover:scale-110 hover:bg-[#049d11]
            focus:outline-none focus:ring-4
            focus:ring-[#00ad0f]/40
            animate-[pulse_2.5s_infinite]
          "
        >
          {/* WhatsApp SVG */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-7 w-7 md:h-8 md:w-8"
          >
            <path
              d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 
                5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 
                2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 
                11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 
                3.276 1.479 5.093 1.479h.005c4.707 0 8.53-3.831 8.532-8.538.002-2.339-.928-4.536
                -2.624-6.192-1.698-1.657-3.895-2.586-6.233-2.586h-.004c-4.707 0-8.531 3.831
                -8.531 8.538 0 1.475.378 2.934 1.111 4.219l-.729 2.663 2.724-.748zm10.16
                -6.325c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272
                -.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223
                -.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059
                -.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296
                .3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242
                -.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016
                -1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709
                .306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 
                2.006-1.413.248-.694.248-1.289.173-1.413z"
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default WhatsAppFAB;
